import React, { useEffect, useState } from "react";
import {
    CardBody,
    Card,
    Col,
    Container,
    Row,
    Input,
    Label,
    Modal,
    Button,
    Form,
    FormGroup,
    CardFooter,
} from "reactstrap";
import apiGlobal from "../global/api.global";
import AsyncSelect from "react-select/async";
import * as Yup from "yup";
import { Field, FieldProps, Formik } from "formik";
import Layout from "../HorizontalMenu/Menu";
import Navbar from "../HorizontalMenu/Navbar";
import "../global/GlobalCSS.css";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "..";
import {
    VesselState,
    getVesselsAction,
    setVesselState,
    setVesselID,
} from "../Store/Generic/ReportingSlice";
import VesselAdditionalInformation from "./AdditionalInformation/AdditionalInformation";
import ToolTip from "../Components/ToolTip";
import VesselConfiguration from "./VesselConfiguration/VesselConfiguration";
import VoyageIcon from "../Media/voyage.png";
import VesselConfig from '../Media/configuration.png';
import AddnInfo from '../Media/additional_detail.png';
import VoyageInformation from "../VoyageInformation/VoyageInformation";
import VesselReportingInfo from "../VesselReportingInfo/VesselReportingInfo";
import DeckOfficerWizard from "../ReportingWizard/DeckOfficerReport/DeckOfficerReporting";
import EngineerWizard from "../ReportingWizard/EngineerReport/EngineerReporting";
import CreateVoyage from "../VoyageInformation/CreateVoyage";
import {
    loadUserVessel,
    loadVesselSubTypes,
    load_Vessel_Types,
} from "./vesselMaster.hooks";
import { errorToast, successToast } from "../Components/Toasts";
import EditVesselReport from "../VesselReportingInfo/EditVesselReport";
import CreateVesselReport from "VesselReportingInfo/CreateVesselReport";
import { Roles } from "shared/constants";
import { hasRole, userVessels } from "utils/auth/authUtils";
import Select from "react-select";
import { useQuery } from "react-query";
import { queryKeyes } from "shared/queryKeys";
import env from "environment/env";
import ErrorTooltip from "Components/ErrorTooltip";
import { errResponse } from "GenericForms/Helper";
import FormValuesDebug from "utils/debugTools/FormValuesDebug";

const VesselMaster = () => {
    /** State varibles start */
    const [modal_xlarge, setmodal_xlarge] = useState(false);
    const { Vessels, VesselState, VoyageID } = useSelector(
        (state: RootState) => state.Reporting
    );
    const [vessels, setVessels] = useState<Array<any>>([]);
    const dispatch = useDispatch();
    let applicableVessels = userVessels();
    /** State variables end */

    /** Queries */
    const { data: UserVessel }: { data: any[] } = useQuery(
        [queryKeyes.vessel.UserVessel.key],
        async () => {
            return await loadUserVessel();
        },
        {
            enabled: true,
            staleTime: Infinity,
        }
    );
    /** Queries end */

    /** useEffect */
    /** Update global vessel state */
    useEffect(() => {
        dispatch(getVesselsAction("vessel_master"));
    }, [dispatch]);
    /**  */
    useEffect(() => {
        let arr: any = [];
        if (Vessels && hasRole(Roles.MASTER)) {
            arr = Vessels?.filter((vessel) =>
                vessel.display === true && applicableVessels?.includes(vessel?.id) &&
                UserVessel?.filter(
                    (item: any) => item.constant === Roles.MASTER
                )
            );
        } else if (Vessels && hasRole(Roles.CHIEFENGINEER)) {
            arr = Vessels?.filter((vessel) =>
                vessel.display === true && applicableVessels?.includes(vessel?.id) &&
                UserVessel?.filter(
                    (item: any) => item.constant === Roles.CHIEFENGINEER
                )
            );
        } else {
            arr = Vessels;
        }
        setVessels(arr);
    }, [Vessels, UserVessel, dispatch]);

    const handleVesselState = (row: number, record: VesselState) => {
        dispatch(setVesselID(row));
        dispatch(setVesselState(record));
    };

    const validation = {
        initialValues: {
            vessel_name: "",
            IMO_number: "",
            vessel_type_name: "",
            vessel_sub_type_name: "",
            ice_class: "",
        },
        validationSchema: Yup.object({
            vessel_name: Yup.string().matches(
                /^[A-Za-z0-9 ]{1,50}$/, "Please enter upto 50 alphabets/numbers only"
            ).required("Please enter the vessel name"),
            IMO_number: Yup.string().matches(
                /^[0-9]{7,8}$/, "Please enter upto 8 digits only"
            ).required("Please enter IMO number"),
            vessel_type_name: Yup.number().required("Please select the vessel type name"),
            vessel_sub_type_name: Yup.string().required("Please select the vessel sub type name"),
        })
    }

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge);
        removeBodyCss();
    }

    const iceClassOptions = [
        { id: "IC", label: "IC" },
        { id: "IB", label: "IB" },
        { id: "IA", label: "IA" },
        { id: "IA super", label: "IA super" },
        { id: "NA", label: "NA" },
    ];

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    const customStyle = {
        menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    };

    return (
        <>
            <React.Fragment>
                {VesselState === null && (
                    <>
                        <Layout children={Navbar} />
                        <div className="page-content">
                            <Container fluid>
                                <div className="ele_row">
                                    <h4 className="mb-3">Vessel List</h4>
                                    {hasRole(Roles.ES_ADMIN) && (
                                        <button
                                            type="button"
                                            className="btn btn-primary waves-effect waves-light mb-3"
                                            data-toggle="modal"
                                            data-target=".bs-example-modal-xl"
                                            onClick={() => {
                                                tog_xlarge();
                                            }}
                                        >
                                            <i className="dripicons-plus font-size-16 align-middle me-2"></i>{" "}
                                            Add New
                                        </button>
                                    )}
                                    <Modal
                                        size=""
                                        isOpen={modal_xlarge}
                                        toggle={() => {
                                            tog_xlarge();
                                        }}
                                    >
                                        <div className="modal-header">
                                            <h5
                                                className="modal-title mt-0"
                                                id="myExtraLargeModalLabel"
                                            >
                                                Add New
                                            </h5>
                                            <button
                                                onClick={() => {
                                                    setmodal_xlarge(false);
                                                }}
                                                type="button"
                                                className="close"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body p-0">
                                            <Card className="m-0">
                                                <Formik
                                                    onSubmit={(values: any, actions: any) => {
                                                        actions.setSubmitting(false);
                                                        const handleResponse = (response: any) => {
                                                            if (response.status === 201) {
                                                                successToast("Data saved successfully!");
                                                            }
                                                        };
                                                        apiGlobal
                                                            .post("/vessel_master/", values)
                                                            .then((res) => {
                                                                tog_xlarge();
                                                                handleResponse(res);
                                                            })
                                                            .catch((err) => {
                                                                if (errResponse.includes(err.response.status)) {
                                                                    errorToast(
                                                                        "Internal error occured, please contact the admin"
                                                                    );
                                                                }
                                                            });
                                                    }}
                                                    initialValues={validation.initialValues}
                                                    validationSchema={validation.validationSchema}
                                                >
                                                    {({
                                                        values,
                                                        errors,
                                                        touched,
                                                        handleChange,
                                                        handleSubmit,
                                                        handleBlur,
                                                    }: {
                                                        values: any;
                                                        errors: any;
                                                        touched: any;
                                                        handleChange: any;
                                                        handleSubmit: any;
                                                        handleBlur: any;
                                                    }) => (
                                                        <Form
                                                            onSubmit={handleSubmit}
                                                            noValidate
                                                            autoComplete="off"
                                                        >
                                                            <CardBody>
                                                                <Row>
                                                                    <Col sm={6}>
                                                                        <FormGroup className="mb-3">
                                                                            <Label
                                                                                for="vessel_name"
                                                                                className="asteric mb-0"
                                                                            >
                                                                                Vessel name
                                                                            </Label>
                                                                            <Input
                                                                                type="text"
                                                                                className="form-control"
                                                                                id="vessel_name"
                                                                                name="vessel_name"
                                                                                onBlur={handleBlur}
                                                                                onChange={(e: any) => handleChange(e)}
                                                                                value={values.vessel_name}
                                                                            />
                                                                            {errors?.vessel_name &&
                                                                                touched?.vessel_name &&
                                                                                env.form_validation === true && (
                                                                                    <ErrorTooltip
                                                                                        target={`vessel_name`}
                                                                                        message={errors?.vessel_name}
                                                                                        open={
                                                                                            errors?.vessel_name ? true : false
                                                                                        }
                                                                                    />
                                                                                )}
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col sm={6}>
                                                                        <div className="mb-3">
                                                                            <Label
                                                                                for="IMO_number"
                                                                                className="asteric mb-0"
                                                                            >
                                                                                IMO number
                                                                            </Label>
                                                                            <Input
                                                                                type="text"
                                                                                className="form-control"
                                                                                id="IMO_number"
                                                                                name="IMO_number"
                                                                                onBlur={handleBlur}
                                                                                onChange={(e: any) => handleChange(e)}
                                                                                value={values.IMO_number}
                                                                            />
                                                                            {errors?.IMO_number &&
                                                                                touched?.IMO_number &&
                                                                                env.form_validation === true && (
                                                                                    <ErrorTooltip
                                                                                        target={`IMO_number`}
                                                                                        message={errors?.IMO_number}
                                                                                        open={
                                                                                            errors?.IMO_number ? true : false
                                                                                        }
                                                                                    />
                                                                                )}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={6}>
                                                                        <FormGroup className="mb-3">
                                                                            <div className="mb-3">
                                                                                <Label
                                                                                    className="asteric mb-0"
                                                                                    for="vessel_type_name"
                                                                                >
                                                                                    Select vessel type
                                                                                </Label>
                                                                                <Field name={`vessel_type_name`}>
                                                                                    {({ field, form }: FieldProps) => (
                                                                                        <AsyncSelect
                                                                                            name={field.name}
                                                                                            id="vessel_type_name"
                                                                                            cacheOptions
                                                                                            defaultOptions
                                                                                            loadOptions={load_Vessel_Types}
                                                                                            getOptionLabel={(e: any) =>
                                                                                                e?.vessel_type_name
                                                                                            }
                                                                                            getOptionValue={(e: any) => e?.id}
                                                                                            onBlur={handleBlur}
                                                                                            onChange={(e: any) =>
                                                                                                form.setFieldValue(
                                                                                                    field.name,
                                                                                                    e?.id
                                                                                                )
                                                                                            }
                                                                                            styles={customStyle}
                                                                                            menuPortalTarget={document.querySelector(
                                                                                                ".MuiDialog-root"
                                                                                            )}
                                                                                        />
                                                                                    )}
                                                                                </Field>
                                                                                {errors?.vessel_type_name &&
                                                                                    touched?.vessel_type_name &&
                                                                                    env.form_validation === true && (
                                                                                        <ErrorTooltip
                                                                                            target={`vessel_type_name`}
                                                                                            message={errors?.vessel_type_name}
                                                                                            open={
                                                                                                errors?.vessel_type_name
                                                                                                    ? true
                                                                                                    : false
                                                                                            }
                                                                                        />
                                                                                    )}
                                                                            </div>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col sm={6}>
                                                                        <FormGroup className="mb-3">
                                                                            <div className="mb-3">
                                                                                <Label
                                                                                    className="asteric mb-0"
                                                                                    for="vessel_sub_type_name"
                                                                                >
                                                                                    Select vessel sub type
                                                                                </Label>
                                                                                <Field name={`vessel_sub_type_name`}>
                                                                                    {({ field, form }: FieldProps) => (
                                                                                        <AsyncSelect
                                                                                            name={field.name}
                                                                                            inputId={`vessel_sub_type_name`}
                                                                                            cacheOptions
                                                                                            defaultOptions
                                                                                            loadOptions={loadVesselSubTypes}
                                                                                            getOptionLabel={(e: any) =>
                                                                                                e.vessel_sub_type_name
                                                                                            }
                                                                                            getOptionValue={(e: any) => e.id}
                                                                                            onBlur={handleBlur}
                                                                                            onChange={(e: any) =>
                                                                                                form.setFieldValue(
                                                                                                    field.name,
                                                                                                    e?.id
                                                                                                )
                                                                                            }
                                                                                            menuPortalTarget={document.querySelector(
                                                                                                ".MuiDialog-root"
                                                                                            )}
                                                                                            styles={customStyle}
                                                                                        />
                                                                                    )}
                                                                                </Field>
                                                                                {errors?.vessel_sub_type_name &&
                                                                                    touched?.vessel_sub_type_name &&
                                                                                    env.form_validation === true && (
                                                                                        <ErrorTooltip
                                                                                            target={`vessel_sub_type_name`}
                                                                                            message={
                                                                                                errors?.vessel_sub_type_name
                                                                                            }
                                                                                            open={
                                                                                                errors?.vessel_sub_type_name
                                                                                                    ? true
                                                                                                    : false
                                                                                            }
                                                                                        />
                                                                                    )}
                                                                            </div>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={6}>
                                                                        <Label className="mb-0" for="ice_class">
                                                                            Select vessel's ice class
                                                                        </Label>
                                                                        <Field name={`ice_class`}>
                                                                            {({ field, form }: FieldProps) => (
                                                                                <Select
                                                                                    name={field.name}
                                                                                    inputId={`ice_class`}
                                                                                    options={iceClassOptions}
                                                                                    getOptionLabel={(option) =>
                                                                                        option.label
                                                                                    }
                                                                                    getOptionValue={(option) => option.id}
                                                                                    onBlur={handleBlur}
                                                                                    onChange={(e: any) =>
                                                                                        form.setFieldValue(field.name, e.id)
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                        {errors?.ice_class &&
                                                                            touched?.ice_class &&
                                                                            env.form_validation === true && (
                                                                                <ErrorTooltip
                                                                                    target={`ice_class`}
                                                                                    message={errors?.ice_class}
                                                                                    open={
                                                                                        errors?.ice_class ? true : false
                                                                                    }
                                                                                />
                                                                            )}
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                            <CardFooter>
                                                                <Row>
                                                                    <div className="d-flex flex-wrap gap-5 grp_justify_right">
                                                                        <Button
                                                                            type="submit"
                                                                            color="primary"
                                                                            className="btn_size4_5_cstm"
                                                                        >
                                                                            Save
                                                                        </Button>
                                                                        <Button
                                                                            type="reset"
                                                                            color="danger"
                                                                            className="btn_size4_5_cstm"
                                                                        >
                                                                            Reset
                                                                        </Button>
                                                                    </div>
                                                                </Row>
                                                            </CardFooter>
                                                            <Row className="mt-2">
                                                                <FormValuesDebug
                                                                    values={[
                                                                        values,
                                                                        errors,
                                                                        validation.initialValues,
                                                                    ]}
                                                                />
                                                            </Row>
                                                        </Form>
                                                    )}
                                                </Formik>
                                            </Card>
                                        </div>
                                    </Modal>
                                </div>
                                <CardBody>
                                    <div className="table-responsive" id="owner_table">
                                        <table className="table mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="p-2 align-middle text-center sr-no-width">
                                                        #
                                                    </th>
                                                    <th className="p-2 align-middle">Vessel</th>
                                                    <th
                                                        className="p-2 align-middle text-center"
                                                        colSpan={3}
                                                    >
                                                        Actions
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {vessels.filter((item: any) => item.display === true && applicableVessels?.includes(item?.id))
                                                    .length > 0 ? (
                                                    vessels
                                                        .filter((item: any) => item.display === true)
                                                        .map((vessel: any, index: number) => (
                                                            <tr key={vessel.id}>
                                                                <td className="p-2 align-middle text-center">
                                                                    {index + 1}
                                                                </td>
                                                                <td className="p-2 align-middle">
                                                                    <strong>{vessel.vessel_name}</strong> (
                                                                    {vessel.vessel_type})
                                                                </td>
                                                                <td
                                                                    className="p-2 align-middle text-center"
                                                                    style={{ width: "5%" }}
                                                                >
                                                                    {hasRole(Roles.ES_ADMIN) && (
                                                                        <>
                                                                            <ToolTip
                                                                                target="additional_information"
                                                                                message="Additional information"
                                                                            />
                                                                            <img
                                                                                alt="Additional Details"
                                                                                className='pointer mr-2'
                                                                                src={AddnInfo}
                                                                                height="45"
                                                                                id='additional_information'
                                                                                onClick={() => {
                                                                                    handleVesselState(
                                                                                        vessel.id,
                                                                                        "ADDITIONAL_INFO"
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </>
                                                                    )}
                                                                </td>
                                                                <td
                                                                    className="p-2 align-middle text-center"
                                                                    style={{ width: "5%" }}
                                                                >
                                                                    {hasRole(Roles.ES_ADMIN) && (
                                                                        <>
                                                                            <ToolTip
                                                                                target="vessel_configuration"
                                                                                message="Vessel configuration"
                                                                            />
                                                                            <img
                                                                                alt="Additional Details"
                                                                                className='pointer mr-2'
                                                                                src={VesselConfig}
                                                                                height="30"
                                                                                id='vessel_configuration'
                                                                                onClick={() => {
                                                                                    handleVesselState(
                                                                                        vessel.id,
                                                                                        "VESSEL_CONFIG"
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </>
                                                                    )}
                                                                </td>
                                                                <td
                                                                    className="p-2 align-middle text-center"
                                                                    style={{ width: "5%" }}
                                                                >
                                                                    {(hasRole(Roles.ES_ADMIN) ||
                                                                        hasRole(Roles.MASTER) ||
                                                                        hasRole(Roles.CHIEFENGINEER) ||
                                                                        hasRole(Roles.MANAGER)) && (
                                                                            <>
                                                                                <ToolTip
                                                                                    target="voyage_reporting"
                                                                                    message="Voyage reporting"
                                                                                />
                                                                                <img
                                                                                    alt="Voyage"
                                                                                    src={VoyageIcon}
                                                                                    height="35"
                                                                                    className="mr-2 pointer"
                                                                                    id="voyage_reporting"
                                                                                    onClick={() => {
                                                                                        handleVesselState(
                                                                                            vessel.id,
                                                                                            "VOYAGE_REPORTING"
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            </>
                                                                        )}
                                                                </td>
                                                            </tr>
                                                        ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4}>Loading Vessels...</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Container>
                        </div>
                    </>
                )}
            </React.Fragment>
            {VesselState === "ADDITIONAL_INFO" && <VesselAdditionalInformation />}
            {VesselState === "VESSEL_CONFIG" && <VesselConfiguration />}
            {VesselState === "VOYAGE_REPORTING" && <VoyageInformation />}
            {VesselState === "CREATE_VOYAGE_REPORTING" && <CreateVoyage />}
            {VesselState === "VOYAGE_REPORTING_EDIT" && (
                <CreateVoyage voyageId={VoyageID} />
            )}
            {VesselState === "VESSEL_REPORTING" && <VesselReportingInfo />}
            {VesselState === "CREATE_VESSEL_REPORTING" && <CreateVesselReport />}
            {VesselState === "DO_REPORTING" && <DeckOfficerWizard />}
            {VesselState === "ENGG_REPORTING" && <EngineerWizard />}
            {VesselState === "EDIT" && <EditVesselReport />}
        </>
    );
};

export default VesselMaster;
